import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import gql from "graphql-tag";

@Injectable()
export class AttractionsService {
  constructor(private apollo: Apollo) {}

  getAllAttractions(obj?) {
    console.log(obj, "obj");
    let variables = {};
    if (obj) {
      variables = {
        first: obj.paginationData.pageSize,
        after:
          obj.paginationData.after === undefined
            ? null
            : obj.paginationData.after.endCursor,
        searchParam: obj.searchParam || null,
      };
    }

    return this.apollo.watchQuery({
      query: gql`
        query GetAttractions(
          $first: Int
          $after: String
          $searchParam: String
        ) {
          attractions(first: $first, after: $after, searchParam: $searchParam) {
            pageInfo {
              hasNextPage
              endCursor
            }
            edges {
              cursor
              node {
                id
                name
                slug
                type
                photos {
                  id
                }
                video {
                  id
                }
                location {
                  id
                  name
                }
              }
            }
            totalCount
          }
        }
      `,
      variables,
      fetchPolicy: "network-only",
    }).valueChanges;
  }

  createAttraction(attraction) {
    return this.apollo.mutate({
      mutation: gql`
        mutation createAttraction($name: String!) {
          createAttraction(attraction: { name: $name }) {
            id
            name
            slug
          }
        }
      `,
      variables: {
        name: attraction.name,
      },
    });
  }

  getAttraction(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            attraction(id: "${id}") {
              id
              name
              alternateName
              slug
              seoTitle
              seoDescription
              type
              description
              accommodationType
              geoCoordinate
              amenities
              bestSeason
              cuisines
              published
              private
              premium
              propertyRelease
              internalNotes
              author
              editor
              phoneNumber
              coordinates
              difficulty
              hoursOfOperation
              additionalCost
              rating
              distance
              duration
              altitude
              craftType
              flow
              yearOfEstablishment
              numberOfRooms
              numberOfBeds
              roomTypes
              address
              ownerName
              emailAddress
              activityType
              raftingClass
              locationId
              additionalCosts {
                name
                amount
                description
                perPerson
              }
              gallery {
                id
                path
                url(w:150, h:150)
              }
              featuredPhoto {
                id
                path
                url(w:150, h:150)
              }
              meetTheLocals {
                id
                path
                url(w:150, h:150)
              }
              photos {
                id
                path
                url(w:150, h:150)
                originalUrl
                premium
                private
                credit
                caption
                colors
                mimetype
                editor
                licensedBy
                licensed
                sublicenseable
                owned
              }
              video {
                id
                path
                url
                credit
                premium
                private
                caption
                colors
                mimetype
                editor
                licensedBy
                licensed
                sublicenseable
                owned
              }
              legalDocs{
                id
                path
                url
                filename
                mimetype
                legal

              }
            }
          }
        `,
    }).valueChanges;
  }

  getAttractionMetaData() {
    return this.apollo.watchQuery({
      query: gql`
        {
          availableAttractionTypes {
            key
            name
          }
          availableActivityTypes {
            key
            name
          }
          availableDifficulties {
            key
            name
          }
          availableAccommodationTypes {
            key
            name
          }
          availableAmenities {
            key
            name
          }
          availableFlows {
            key
            name
          }
          availableRaftingClasses {
            key
            name
          }
          availableCuisines {
            key
            name
          }
          availableSeasons {
            key
            name
          }
          allLocations {
            id
            name
          }
        }
      `,
    }).valueChanges;
  }

  update(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation updateAttraction(
          $id: String!
          $slug: String!
          $name: String
          $type: String
          $alternateName: String
          $description: String
          $accommodationType: String
          $amenities: [String]
          $bestSeason: [String]
          $cuisines: [String]
          $published: Boolean
          $private: Boolean
          $premium: Boolean
          $propertyRelease: Boolean
          $internalNotes: String
          $seoTitle: String
          $seoDescription: String
          $author: String
          $editor: String
          $difficulty: String
          $hoursOfOperation: Int
          $additionalCost: Float
          $rating: Float
          $distance: Float
          $duration: Int
          $altitude: Int
          $coordinates: String
          $phoneNumber: String
          $craftType: String
          $flow: String
          $yearOfEstablishment: String
          $numberOfRooms: Int
          $numberOfBeds: Int
          $roomTypes: String
          $address: String
          $ownerName: String
          $emailAddress: String
          $activityType: String
          $raftingClass: String
          $locationId: ID
          $additionalCosts: [AttractionType_AdditionalCostInput]
        ) {
          updateAttraction(
            attraction: {
              id: $id
              slug: $slug
              name: $name
              type: $type
              alternateName: $alternateName
              description: $description
              accommodationType: $accommodationType
              amenities: $amenities
              bestSeason: $bestSeason
              cuisines: $cuisines
              published: $published
              private: $private
              premium: $premium
              propertyRelease: $propertyRelease
              internalNotes: $internalNotes
              author: $author
              editor: $editor
              difficulty: $difficulty
              hoursOfOperation: $hoursOfOperation
              additionalCost: $additionalCost
              rating: $rating
              distance: $distance
              duration: $duration
              altitude: $altitude
              coordinates: $coordinates
              phoneNumber: $phoneNumber
              craftType: $craftType
              flow: $flow
              yearOfEstablishment: $yearOfEstablishment
              numberOfRooms: $numberOfRooms
              numberOfBeds: $numberOfBeds
              roomTypes: $roomTypes
              address: $address
              ownerName: $ownerName
              emailAddress: $emailAddress
              activityType: $activityType
              raftingClass: $raftingClass
              locationId: $locationId
              additionalCosts: $additionalCosts
              seoTitle: $seoTitle
              seoDescription: $seoDescription
            }
          ) {
            success
          }
        }
      `,
      variables: {
        id: obj.id,
        slug: obj.slug,
        name: obj.name,
        type: obj.type,
        alternateName: obj.alternateName,
        description: obj.description,
        accommodationType: obj.accommodationType,
        amenities: obj.amenities,
        bestSeason: obj.bestSeason,
        cuisines: obj.cuisines,
        published: obj.published,
        private: obj.private,
        premium: obj.premium,
        propertyRelease: obj.propertyRelease,
        internalNotes: obj.internalNotes,
        author: obj.author,
        editor: obj.editor,
        difficulty: obj.difficulty,
        hoursOfOperation: obj.hoursOfOperation,
        additionalCost: obj.additionalCost,
        distance: obj.distance,
        rating: obj.rating,
        duration: obj.duration,
        altitude: obj.altitude,
        coordinates: obj.coordinates,
        phoneNumber: obj.phoneNumber,
        craftType: obj.craftType,
        flow: obj.flow,
        yearOfEstablishment: obj.yearOfEstablishment,
        numberOfRooms: obj.numberOfRooms,
        numberOfBeds: obj.numberOfBeds,
        roomTypes: obj.roomTypes,
        address: obj.address,
        ownerName: obj.ownerName,
        emailAddress: obj.emailAddress,
        activityType: obj.activityType,
        raftingClass: obj.raftingClass,
        additionalCosts: obj.additionalCosts,
        locationId: obj.locationId,
        seoTitle: obj.seoTitle,
        seoDescription: obj.seoDescription,
      },
    });
  }

  delete(obj) {
    return this.apollo.mutate({
      mutation: gql`
        mutation removeAttraction {
          removeAttraction(attraction: {id: "${obj.id}"}) {
            success
          }
        }
      `,
    });
  }

  getAllAttraction() {
    return this.apollo.watchQuery({
      query: gql`
        {
          allAttractions {
            id
            name
            published
          }
        }
      `,
    }).valueChanges;
  }
  getAttractionGallery(id: string) {
    return this.apollo.watchQuery({
      query: gql`
          {
            attraction(id: "${id}") {
              id
              description
              published

              gallery {
                id
                path
                url(w:150, h:150)
              }
              featuredPhoto {
                id
                path
                url(w:150, h:150)
              }
              meetTheLocals {
                id
                path
                url(w:150, h:150)
              }
            }
          }
        `,
    }).valueChanges;
  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/attractions.service.ts